var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form',{ref:"PaymentInformations",staticClass:"PaymentMethod__Form--Custom Form--Custom"},[_c('div',{staticClass:"PaymentMethod__Form--PayPal"},[_c('el-row',{attrs:{"gutter":20}},[_c('div',{attrs:{"id":"ppplus"}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }